import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBehanceComponent } from './simple-icons-behance.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBehanceComponent ],
    exports:      [ SimpleIconsBehanceComponent ],
    bootstrap:    []
})
export class SimpleIconsBehanceModule {}
